export const hiddenPaymentMethodStoreKey = 'favrit.hiddenPaymentMethodSettings';
export const storageKeyPaymentMethodSettings = `favrit.paymentMethodSettings`;
export const terminalStatesStoreKey = 'favrit.terminalStates';
